import axios from 'axios';

import { getConfig } from '../../AppConfig';
import { readRecovery } from '../readRecovery';

const config = getConfig();

const customAxios = axios.create({
  baseURL: config.apiBaseUrl,
  paramsSerializer: {
    indexes: true,
  },
});

// Install before the auth/data interceptors, so transport errors are observed
// before those interceptors normalize the error or unwrap response.data.
customAxios.interceptors.request.use((request) => readRecovery.begin(request));
customAxios.interceptors.response.use(
  (response) => {
    readRecovery.finish(response.config);
    return response;
  },
  (error) => {
    readRecovery.finish(error.config, error);
    return Promise.reject(error);
  }
);

export default customAxios;
